import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Search } from '../search';
import { Tabs } from '../tabs';
import { AddButton } from 'src/modules/contentList/components/addButton/addButton';
import { UploadFilesButton } from 'src/modules/contentList/components/uploadFilesButton';
export default function Header({ onSearch }) {
    return (_jsxs("div", { className: "mb-5 flex flex-col justify-between gap-5 min-[1320px]:flex-row min-[1320px]:gap-0", children: [_jsx(Tabs, {}), _jsxs("div", { className: "flex flex-wrap gap-4 min-[1320px]:ml-4 min-[1320px]:justify-start", children: [_jsx(Search, { onSearch: onSearch }), _jsx(UploadFilesButton, {}), _jsx(AddButton, {})] })] }));
}
